import { render, staticRenderFns } from "./UserScoreList.vue?vue&type=template&id=3bcf7c40&scoped=true&"
import script from "./UserScoreList.vue?vue&type=script&lang=js&"
export * from "./UserScoreList.vue?vue&type=script&lang=js&"
import style0 from "./UserScoreList.vue?vue&type=style&index=0&id=3bcf7c40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf7c40",
  null
  
)

component.options.__file = "UserScoreList.vue"
export default component.exports